import React, { useState } from "react";
import toast from "react-hot-toast";
import { Col, Form, Input, Row } from "antd";
import { Editor } from "@tinymce/tinymce-react";
import { AddUpdateEmailTemplateApi } from "../../../../api/request/emailTemplate/emailTemplate.js";
import LoadableButton from "../../../../components/buttons/LoadableButton.jsx";

const TemplateForm = ({
  mode,
  setMode,
  selectedTemplate,
  getEmailTemplateList,
}) => {
  const [form] = Form.useForm();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [content, setContent] = useState(selectedTemplate?.email_message || "");

  const onSubmitTemplate = async (values) => {
    try {
      setIsSubmitLoading(true);
      let data = {};

      const params = {
        ...(mode === "edit" && { email_temp_id: selectedTemplate?.id }),
        ...values,
        email_message: content,
      };

      if (mode === "edit") {
        const res = await AddUpdateEmailTemplateApi(params);
        data = res?.data;
      } else {
        const res = await AddUpdateEmailTemplateApi(params);
        data = res?.data;
      }

      if (data.status) {
        setIsSubmitLoading(false);
        toast.success(data.message);
        form.resetFields();
        setMode("view");
        getEmailTemplateList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsSubmitLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="font-semibold text-xl mb-4">
        {mode === "edit" ? "Edit Template" : "Create Template"}
      </h2>

      <Form
        form={form}
        layout="vertical"
        initialValues={selectedTemplate}
        onFinish={onSubmitTemplate}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="template_name"
              label="Template Name"
              rules={[
                {
                  required: true,
                  message: "Please enter the template name",
                },
              ]}
            >
              <Input placeholder="Enter template name" size="large" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="subject"
              label="Subject"
              rules={[{ required: true, message: "Please enter the subject" }]}
            >
              <Input placeholder="Enter subject" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Email Message"
          required
          rules={[
            { required: true, message: "Please enter the email message" },
          ]}
        >
          <Editor
            apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
            initialValue={selectedTemplate?.email_message}
            init={{
              height: 300,
              menubar: false,
              toolbar:
                "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
            }}
            onEditorChange={(content) => setContent(content)}
          />
        </Form.Item>
        <div className="mt-5 flex gap-3">
          <LoadableButton
            className="bg-primary text-sm text-white font-medium px-8 py-2 rounded-lg themeHover duration-500"
            type="submit"
            lable="Submit"
            isLoading={isSubmitLoading}
            loadingLable="Submitting Template..."
          />
          <button
            className="flex items-center px-4 py-1.5 font-medium border border-primary text-primary rounded-lg"
            onClick={() => setMode("view")}
          >
            Cancel
          </button>
        </div>
      </Form>
    </div>
  );
};

export default TemplateForm;
